import {
  FormHelperText,
  formHelperTextClasses,
  Stack,
  SxProps,
} from '@mui/material'
import { memo } from 'react'
import { ErrorIcon } from '../icons'

interface Props {
  message?: any
  sx?: SxProps
}

const ErrorMessage = memo(({ message, sx }: Props) => {
  if (!message) return null
  return (
    <Stack
      direction="row"
      spacing="5px"
      mt="10px"
      color="#FF3030"
      sx={{ ...(sx || {}) }}
    >
      <ErrorIcon />
      <FormHelperText
        error
        sx={{
          width: '100%',
          fontSize: '12px',
          fontWeight: '400',
          lineHeight: '115%',
          marginLeft: '9px',
          flex: 'none',
          letterSpacing: '0.045em',
          [`&.${formHelperTextClasses.error}`]: {
            color: 'error.light',
            marginLeft: '9px',
            marginTop: '1px',
          },
        }}
      >
        {message}
      </FormHelperText>
    </Stack>
  )
})

export default ErrorMessage
